var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`text-body-2 d-flex flex-wrap ${
    _vm.vertical ? `flex-column` : `align-center`
  }`},_vm._l((_vm.items),function(value,name,index){return _c('div',{key:index,class:`${_vm.stacked ? `pr-9 pb-1` : !_vm.vertical ? `pr-6` : ``} 
    ${
      _vm.vertical
        ? _vm.stacked
          ? 'pb-3'
          : 'pb-2'
        : _vm.$vuetify.breakpoint.xsOnly
        ? 'pb-1'
        : ''
    }`},[(typeof value == 'object')?_c('div',{class:`d-flex ${_vm.vertical ? `flex-column` : `align-center`}
      ${_vm.$vuetify.breakpoint.xsOnly ? 'flex-wrap' : ''}`},[_c('div',{class:`font-italic ${_vm.stacked ? `pr-5 secondary--text` : ``}`,style:(`${_vm.$vuetify.breakpoint.xsOnly ? 'width: 100%' : ''}`)},[_vm._v(" "+_vm._s(name)),(!_vm.stacked)?_c('span',[_vm._v(":")]):_vm._e()]),_vm._l((value),function(value2,name2,index2){return _c('div',{key:index2,class:`${_vm.stacked ? `pr-5` : ``} ${
          _vm.stacked && _vm.vertical ? 'pb-1' : ''
        }`},[_c('jcdc-labeled-text-pair',{attrs:{"name":name2,"value":value2,"label-width":_vm.$vuetify.breakpoint.xsOnly
              ? null
              : _vm.vertical && _vm.alignValues
              ? _vm.labelWidth
              : null,"vertical":_vm.vertical,"stacked":_vm.stacked,"color":_vm.color,"child":""}})],1)})],2):_c('div',[_c('jcdc-labeled-text-pair',{attrs:{"name":name,"value":value,"label-width":_vm.$vuetify.breakpoint.xsOnly
            ? null
            : _vm.vertical && _vm.alignValues
            ? _vm.labelWidth
            : null,"vertical":_vm.vertical,"stacked":_vm.stacked,"color":_vm.color}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }